import React, { type FC } from 'react'
import { StoreDeliveryFeeTag } from './store-delivery-fee-tag/StoreDeliveryFeeTag'
import { StoreDeliveryFeeText } from './store-delivery-fee-text/StoreDeliveryFeeText'
import styles from './StoreDeliveryFee.module.scss'

interface Props {
  hasSpecialFee?: boolean
  shouldShowPrimeFee?: boolean
  deliveryFee: {
    baseFee: string
    effectiveFee?: string
    isPrimeDeliveryFee?: boolean
    isSurged?: boolean
    isFreeDeliveryFee?: boolean
    isDiscountedDeliveryFee?: boolean
  }
}

export const StoreDeliveryFeeInfo: FC<Props> = ({
  shouldShowPrimeFee,
  hasSpecialFee,
  deliveryFee,
}) => (
  <div className={styles.deliveryFee}>
    {hasSpecialFee ? (
      <StoreDeliveryFeeTag deliveryFee={deliveryFee} />
    ) : (
      <StoreDeliveryFeeText baseFee={deliveryFee.baseFee} shouldShowPrimeFee={shouldShowPrimeFee} />
    )}
  </div>
)
